export default "__VITE_ASSET__BlSyxNpY__"